
<form class="edit-form" [formGroup]="formGroup" (submit)="onSubmit()">
  <section *ngFor="let group of editConfig.groups" class="edit-form-category">
    <h3 *ngIf="!fieldsOnly">{{group.name}}</h3>

    <div [ngClass]="{'base-input': true, 'readonly': input.readonly}" *ngFor="let input of group.configs">

      <mat-form-field appearance="outline">

        <mat-label>{{input.name | titlecase}}</mat-label>

        <input matInput [formControlName]="input.field" [name]="input.field" *ngIf="input.type === EInputType.TEXT"/>
        <input matInput type="number" pattern="[0-9]+" [formControlName]="input.field" [name]="input.field" *ngIf="input.type === EInputType.NUMBER"/>
        <input matInput [formControlName]="input.field" *ngIf="input.type === EInputType.DISABLED" readonly class="mat-form-field-disabled"/>

        <input matInput [formControlName]="input.field" *ngIf="input.type === EInputType.PASSWORD" [type]="visible.includes(input.field) ? 'text' : 'password'"/>
        <mat-icon class="button" matSuffix role="button" (click)="toggle(input.field)" *ngIf="input.type === EInputType.PASSWORD && visible.includes(input.field)">visibility</mat-icon>
        <mat-icon class="button" matSuffix role="button" (click)="toggle(input.field)" *ngIf="input.type === EInputType.PASSWORD && !visible.includes(input.field)">visibility_off</mat-icon>


        <input matInput [formControlName]="input.field" *ngIf="input.type === EInputType.DATE"  type="date"/>
        <input matInput [formControlName]="input.field" *ngIf="input.type === EInputType.DATETIME" type="datetime-local"/>
        <input matInput [formControlName]="input.field" *ngIf="input.type === EInputType.EMAIL" type="email"/>

        <input matInput [formControlName]="input.field" type="text" class="d-none"  *ngIf="input.type === EInputType.FILE"/>

        <label class="file-cnt" *ngIf="input.type === EInputType.FILE">
          <input (change)="onChange(input, $event)" type="file" class="d-none"/>

          <mat-icon class="file-icon">upload_file</mat-icon>

          {{ formGroup.value[input.field] }}
        </label>

        <img class="pw-img" [src]="environment.apiUrl + '/files/' +formGroup.value[input.field]" *ngIf="input.type === EInputType.FILE_PREVIEW && formGroup.value[input.field]"/>
        <input matInput [formControlName]="input.field" type="text" class="d-none"  *ngIf="input.type === EInputType.FILE_PREVIEW"/>

        <label class="file-cnt" *ngIf="input.type === EInputType.FILE_PREVIEW">
          <input (change)="onChange(input, $event)" type="file" class="d-none"/>

          <mat-icon class="file-icon">upload_file</mat-icon>

          {{ formGroup.value[input.field] ? formGroup.value[input.field].slice(0,20) + '...' : '' }}
        </label>
        <input matInput [formControlName]="input.field" type="text" class="d-none"  *ngIf="input.type === EInputType.FILE_WITH_MARKS"/>

        <label class="file-cnt" *ngIf="input.type === EInputType.FILE_WITH_MARKS">
          <input (change)="onChange(input, $event)" type="file" class="d-none"/>

          <mat-icon class="file-icon">upload_file</mat-icon>

          {{ formGroup.value[input.field] }}
        </label>

        <img class="file_with_marks" (mouseup)="applyTarget($event)" [src]="cdnUrl + formGroup.value[input.field]" *ngIf="input.type === EInputType.FILE_WITH_MARKS && formGroup.value[input.field]">

        <div class="marks_tools" *ngIf="input.type === EInputType.FILE_WITH_MARKS && formGroup.value[input.field]">

          <div *ngFor="let mark of marksTargets" [class]="{marks_tool: true, active: marksTarget===mark}" (click)="pickMarksTarget(mark)">{{mark}}</div>

        </div>


        <input type="text" class="d-none" matInput [formControlName]="input.field" *ngIf="input.type === EInputType.BOOLEAN"/>
        <mat-checkbox (change)="onChangeBoolean(input.field, $event)" [ngModelOptions]="{standalone: true}" [(ngModel)]="item[input.field]" *ngIf="input.type === EInputType.BOOLEAN">
          {{ item[input.field] ? 'Yes' : 'No' }}
        </mat-checkbox>

        <mat-select [formControlName]="input.field" *ngIf="input.type === EInputType.SELECT && input.options">
          <mat-option *ngFor="let option of input.options()" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>

        <textarea matInput [formControlName]="input.field" *ngIf="input.type === EInputType.TEXTAREA" rows="5"></textarea>

        <mat-error *ngIf="hasError(input.field)">
          {{getError(input.field)}}
        </mat-error>


        <input type="text" class="d-none" matInput [formControlName]="input.field" *ngIf="input.type === EInputType.ROLE_ACCESS"/>
        <div  class="roles" *ngIf="input.type === EInputType.ROLE_ACCESS">
          <div class="roles-line" *ngFor="let module of modules">
            <mat-checkbox [ngModelOptions]="{standalone: true}" [(ngModel)]="data[input.field]['read_'+module.key]" (change)="onRoleSelect(input.field, 'read_'+module.key)">Read {{module.label || module.key | titlecase}}</mat-checkbox>
            <mat-checkbox [ngModelOptions]="{standalone: true}" [(ngModel)]="data[input.field]['write_'+module.key]"  (change)="onRoleSelect(input.field, 'write_'+module.key)">Write {{module.label || module.key | titlecase}}</mat-checkbox>
          </div>
        </div>


        <input type="text" class="d-none" matInput *ngIf="input.type === EInputType.RICH"/>
        <editor *ngIf="input.type === EInputType.RICH"
                [formControlName]="input.field"
                [plugins]="'lists table media link'"
                [apiKey]="'tqlv711xg0npv3ev016nooa49pupdyyse5v3vbd45dr4c23k'"
          [init]="{ }"
        ></editor>
      </mat-form-field>



    </div>

  </section>


  <div class="tools" *ngIf="!fieldsOnly">
    <button mat-flat-button class="but" type="submit" [disabled]="!this.formGroup.valid">Save</button>
    <button mat-flat-button class="but" type="button" (click)="onBack()">Back</button>
  </div>
  </form>
